/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogTabContainer_user$ref: FragmentReference;
declare export opaque type LogTabContainer_user$fragmentType: LogTabContainer_user$ref;
export type LogTabContainer_user = {|
  +id: string,
  +$refType: LogTabContainer_user$ref,
|};
export type LogTabContainer_user$data = LogTabContainer_user;
export type LogTabContainer_user$key = {
  +$data?: LogTabContainer_user$data,
  +$fragmentRefs: LogTabContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LogTabContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6fa1db8df0de1d3467b7dfc64de4d82d';
module.exports = node;
